import { Platform, Pressable, StyleSheet, Text, View } from "react-native";
import { Image } from "expo-image";
import Fontisto from '@expo/vector-icons/Fontisto';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Icon, IconButton } from "native-base";
import { Ionicons } from "@expo/vector-icons";
import Entypo from '@expo/vector-icons/Entypo';
import { Character, RoleDisplayImage } from "../../data/types";
import { useTypedSelector } from "../../redux/store";
import { COIN_ARR_NUMBER } from "../../data/template";
import { PayTipModal } from "../pay/payTipModal";
import { PayAPI } from "../../data/payApi";

export default function ChatHeader({
  character,
  prveRoute,
  handleImagePress,
  viewAllChange
}:{
  character: Character;
  prveRoute: (route?: string)=>void;
  handleImagePress: (medias: {video?: string; image: string}[], index: number)=>void;
  viewAllChange: ()=>void;
}){
  const dispatch = useDispatch();
  const [heard, setHeard] = useState(0);
  const [images, setImages] = useState<RoleDisplayImage[]>([]);
  const userCurrent = useTypedSelector(state=> state.userCurrent);

  const [checkPay, setCheckPay] = useState({
    coin: 50, index: 0, open: false
  });

  const heardColor = useMemo(() => {
    let col_arr = [ "#FFFFFF", "#FFEEEE", "#FFCCCC", "#FFAAAA", "#FF9999", "#FF8888", "#FF6666", "#FF4444", "#FF3333", "#FF0000" ];
    let math_num = Math.floor(heard / 10);
    if(math_num >= 10) math_num = 9;
    return col_arr[math_num];
  },[heard]);

  const lookChange = (index: number) => {
    if(!images.length) return;
    let check = images[index];
    if(check.disabled){
      setCheckPay({ coin: check.coin, index, open: true })
      return;
    }
    let media_arr = images.filter(item=> item.disabled);
    let image_arr = media_arr.map(item=> ({ image: item.url }) )
    handleImagePress(image_arr, index);
  };

  const loadCharacters = async (refresh = false) => {
    // if (loading || (!hasMore && !refresh)) return;
    try {
      let list: RoleDisplayImage[] = [];
      
      if( !Array.isArray( character.albums ) && character.albums){
        let include_arr: number[] = [];
        let closeup = character.albums.closeup;
        if( userCurrent.sub_list.includes(character.name) ){
          include_arr = closeup.map((_,idx)=>idx);
        }else{
          let arr = userCurrent.unlock_images[ character.name ];
          include_arr = arr || [];
        };
        list = closeup.map((url,idx)=>{
          return {
            url, id: idx.toString(), disabled: !include_arr.includes(idx),
            coin: COIN_ARR_NUMBER[idx] || 50
          }
        });
      };
      setImages(list.slice(0,4));
    } catch (err) {
      console.log(err);
    }
  };
  
  const payChanges = (state: string)=>{
    setCheckPay({ coin: 50, index: 0, open: false });
    if(state === "success"){
      let { unlock_images } = userCurrent;
      let copy_obj = {...unlock_images};
      
      let check_arr = copy_obj[character.name] || [];
      let new_arr = [...check_arr]
      new_arr.push( checkPay.index );
      copy_obj[character.name] = new_arr;
      PayAPI.updateProfiles(
        dispatch,
        {unlock_images: copy_obj}
      );
    }else{
      prveRoute("Gem")
    }
  }

  useEffect(()=>{
    loadCharacters();
  },[userCurrent]);
  
  return (
    <View style={{
      width: "100%", height: 60, padding: 10, backgroundColor: "rgb(25,27,44)",
      flexDirection: "row", position: "relative", zIndex: 10,
    }}>
      <IconButton
        icon={<Icon as={Ionicons} name="arrow-back" />}
        onPress={()=> prveRoute() }
        zIndex={1}
        _icon={{ color: 'white' }}
      />
      <View style={{
        width: 40, height: 40, borderRadius: 20, overflow: "hidden",
        marginLeft: 10,
      }}>
        <Image
          source={{uri: character.imageUrl}}
          style={{
            width: "100%", height: "100%",
          }}
        />
      </View>
      <View style={{
        flex: 1, marginLeft: 15,
      }}>
        <Text style={{ fontSize: 18, color: "white", fontWeight: "bold" }}>
          {character.name}
        </Text>
      </View>

      <View style={{
        paddingTop: 5, paddingBottom: 5, gap: 10,
        flexDirection: "row", alignItems: "center"
      }}>
        <Pressable onPress={()=> {}}>
          <View style={{ flexDirection: "row", alignItems: "center", gap: 5 }}>
            <MaterialCommunityIcons name="heart" size={20} color={heardColor} />
            <Text style={{ color: '#FFFFFF', fontSize: 16 }}>{heard}%</Text>
          </View>
        </Pressable>
        <View style={styles.nav_right_ctx}>
          <Fontisto name="database" size={12} color="#FFFFFF" />
          <Text style={{ color: '#FFFFFF', fontSize: 14 }}>{userCurrent.coins}</Text>
        </View>
      </View>

      <View style={{
        position: "absolute", left: 0, top: 60,
        width: "100%", height: 70, backgroundColor: "rgb(25,27,44)",
        padding: 5, paddingLeft: 10,
        flexDirection: "row", alignItems: "center",
        gap: 10,
      }}>
        {images.map((item, index) => (
          <Pressable key={index} style={{
            width: 60, height: 60, borderRadius: 10, overflow: "hidden",
            position: "relative"
          }} onPress={()=> lookChange(index) }>
            <Image source={{uri: item.url}}
              blurRadius={item.disabled ? 6 : 0}
              style={{ width: "100%", height: "100%" }}
            />
            {item.disabled && (
              <View style={styles.lockCoins}>
                <Entypo name="lock" size={24} style={{fontWeight: "900"}}
                  color="#FFFFFF" />
                <Text style={{
                  color: "#FFFFFF", fontSize: 12, fontWeight: "bold",
                  marginTop: 4
                }}>
                  {item.coin} Coin
                </Text>
              </View>
            )}
          </Pressable>
        ))}
        <Pressable style={{
          width: 60, height: 60, borderRadius: 10, overflow: "hidden",
          borderWidth: 1, borderColor: "#007AFF", borderStyle: "solid",
          justifyContent: "center",
        }} onPress={viewAllChange}>
          <Text style={{
            fontSize: 14, color: "#007AFF", textAlign: "center",
          }}>
            View All
          </Text>
        </Pressable>
      </View>
      
      <PayTipModal
        open={ checkPay.open } setOpen={()=>{
          setCheckPay({...checkPay, open: false});
        }} onChange={payChanges}
        tipText="Unlock this image with coins" delCoins={ checkPay.coin } />
    </View>
  )
}

const styles = StyleSheet.create({
  nav_right_ctx: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    borderRadius: 20,
    padding: 2,
    paddingLeft: 12,
    paddingRight: 12,
    borderWidth: 1,
    borderColor: "#007AFF",
    borderStyle: "solid"
  },
  lockCoins:{
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  }
});